import { IconLot } from "icons";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Divider, FormControlLabel, Popover } from "@material-ui/core";
import { useState, useEffect } from "react";
import { locationSelectorStyle } from "./styles";
import Checkbox from '@mui/material/Checkbox';
import { LocationFilterTypes, locationTypes } from "./LocationsViewConsts";
import Authorize from "../../../../../../components/Authorize";

const LocationsViewSelector = ({ locationFilters, setLocationFilters }) => {
    const classes = locationSelectorStyle();
    const [anchorEl, setAnchorEl] = useState(null);

    const openPanel = (e) => {
        setAnchorEl(e.currentTarget);
    }

    const closePanel = () => {
        setAnchorEl();
    }

    const validateAllSelector = (locationsFilter, location, selected) => {
        if ((selected && +location === 0)
            || locationsFilter?.length === 0 ) {

            locationsFilter = [];
        }
        else {
            locationsFilter = locationsFilter.filter(value => +value !== 0);
        }
        return locationsFilter;
    }

    const onChangeFilter = (location, val) => {
        let locationsFilter = [...(locationFilters?.['locationsFilter']?.value ?? [])]
        if(locationsFilter?.length === 0 && +location === 0 && !val) {
            closePanel();
            return;
        }
        if (val && +location !== 0 && locationsFilter?.find(v => +v === 0)) {
            locationsFilter = [];
        }
        if (val) {
            locationsFilter = [...locationsFilter, location]
        } else {
            locationsFilter = locationsFilter?.filter(value => value != location);
        }
        setLocationFilters({ ...locationFilters, 'locationsFilter': { value: validateAllSelector(locationsFilter, location, val) } });
    }

    const isChecked = (value) => {
        let locationsFilter = [...(locationFilters?.['locationsFilter']?.value ?? [])]
        return (locationsFilter?.length === 0 && +value === 0) 
        || (locationsFilter?.length !== 0 && !!locationsFilter?.find(v => v === value));
            
    }

    const render = (index, location, locationTypes) => {
        return (<div key={index} id={index}>
            <div className={classes.lotFilterCheck}>
                <FormControlLabel
                    control={<Checkbox
                        checked={isChecked(location.value)}
                        onChange={(e, val) => {
                            onChangeFilter(location.value, val)
                        }}
                    />}
                />
                <div className={classes.ItemName}> {location?.name}</div>
                <div>{location?.icon && location.icon({
                    type: location?.lotType,
                    ownedByTenant: location?.id === LocationFilterTypes.PMF_LOTS
                })}</div>
            </div>
            {index !== locationTypes?.length - 1 && <Divider />}
        </div>)
    }

    const selectedLabel = () => {
        const locationsFilter = [...(locationFilters?.['locationsFilter']?.value ?? [])];
    
        if (locationsFilter.length === 0) {
            return locationTypes?.find(v => v?.value === "0")?.name;
        }
    
        const names = locationsFilter
            .map(id => locationTypes?.find(v => v?.value === id)?.name); 
                
        if (names.length === 0) return '';
    
        if (names.length === 1) {
            return names[0];
        }
    
        if (names.length === 2) {
            return `${names[0]}, ${names[1]}`;
        }
    
        const extraCount = names.length - 2;
        return `${names[0]}, ${names[1]} (+${extraCount} more)`;
    };
    

    return (
        <>
            <div className={classes.lotFilterContainer} onClick={openPanel}>
                <div className={classes.lotFilterHeader}>
                    <IconLot color={"#0090FE"} height='24' width='24' />
                    <div className={classes.lotFilterLabel}>{selectedLabel()}</div>
                </div>
                <ExpandMoreIcon />
            </div>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={closePanel}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                PaperProps={{
                    style: { width: '18%' },
                }}
            >
                <div className={classes.content}>
                    {locationTypes?.map((location, index) => location?.permission ?
                        <Authorize profile={location?.permission}>
                            {render(index, location, locationTypes)}
                        </Authorize> : render(index, location, locationTypes))}
                </div>
            </Popover>
        </>
    )
}
export default LocationsViewSelector;